<template>
  <svg
    xmlns="http://www.w3.org/2000/svg" 
  >
    <path fill-rule="evenodd" d="M11,8c0-.3-.2-.5-.5-.5h-3.8s1.1-1.1,1.1-1.1c.2-.2.2-.5,0-.7-.2-.2-.5-.2-.7,0l-2,2s0,0,0,0c-.2.2-.2.5,0,.7l2,2c.2.2.5.2.7,0,.2-.2.2-.5,0-.7l-1.1-1.1h3.8c.3,0,.5-.2.5-.5"/>
    <path d="M13,0c1.1,0,2,.9,2,2v1h-1v-1c0-.6-.4-1-1-1H3c-.6,0-1,.4-1,1v12c0,.6.4,1,1,1h10c.6,0,1-.4,1-1v-1h1v1c0,1.1-.9,2-2,2H3c-1.1,0-2-.9-2-2V2C1,.9,1.9,0,3,0h10"/>
    <path d="M15.5,5c.3,0,.5.2.5.5s-.2.5-.5.5h-2c-.3,0-.5-.2-.5-.5s.2-.5.5-.5h.5s0-.5,0-.5c0-.3.2-.5.5-.5s.5.2.5.5v.5s.5,0,.5,0ZM15.5,8c.3,0,.5.2.5.5s-.2.5-.5.5h-2c-.3,0-.5-.2-.5-.5s.2-.5.5-.5h.5s0-.5,0-.5c0-.3.2-.5.5-.5s.5.2.5.5v.5s.5,0,.5,0ZM15.5,11c.3,0,.5.2.5.5s-.2.5-.5.5h-2c-.3,0-.5-.2-.5-.5s.2-.5.5-.5h.5s0-.5,0-.5c0-.3.2-.5.5-.5s.5.2.5.5v.5s.5,0,.5,0Z"/>
  </svg>
</template>
